'use client';

import {Icon} from '@udemy-v2/icons';
import {LocalizedHtml, useI18n} from '@udemy-v2/i18n';
import styles from './blended-offer-badge.module.scss';

export interface BlendedOfferBadgeProps {
    variant: 'monthly' | 'annual';
    termsUrl?: string;
    onLifetimeAccessClick: () => void;
}

export const BlendedOfferBadge = ({
    variant,
    termsUrl,
    onLifetimeAccessClick,
}: BlendedOfferBadgeProps) => {
    const {gettext} = useI18n();

    const html =
        variant === 'monthly'
            ? gettext(
                  '<span class="emphasis">Get</span> <span class="lifetime-access-link">lifetime access</span> to this course for free after your first Personal Plan renewal. <span class="terms-link">Terms apply</span>',
              )
            : gettext(
                  '<span class="emphasis">Get</span> <span class="lifetime-access-link">lifetime access</span> to this course for free with an annual Personal Plan subscription. <span class="terms-link">Terms apply</span>',
              );

    return (
        <div className={styles['value-prop-badge']} data-purpose="blended-offer-badge">
            <Icon
                className={styles['value-prop-icon']}
                glyph="verified"
                color="positive"
                size="small"
                label=""
            />
            <span className={styles['value-prop-text']}>
                <LocalizedHtml
                    html={html}
                    interpolate={{
                        emphasis: <span className={styles['emphasis']} />,
                        'lifetime-access-link': (
                            <button
                                type="button"
                                className={styles['lifetime-access-link']}
                                onClick={onLifetimeAccessClick}
                                data-purpose="blended-offer-lifetime-access-link"
                            />
                        ),
                        'terms-link': termsUrl ? (
                            <a
                                href={termsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles['terms-link']}
                                data-purpose="blended-offer-terms-link"
                            />
                        ) : (
                            <span />
                        ),
                    }}
                />
            </span>
        </div>
    );
};
